// extracted by mini-css-extract-plugin
export default {"footerHeading":"FooterHeading_footerHeading__ORvj2"};